import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
export const undo = createAction('history/undo');
export const redo = createAction('history/redo');
export const snapshot = createAction('history/snapshot');
export const back = createAsyncThunk('history/back', async (_, { dispatch }) => {
    dispatch(undo());
    await dispatch(change());
});
export const forward = createAsyncThunk('history/forward', async (_, { dispatch }) => {
    dispatch(redo());
    await dispatch(change());
});
export const change = createAsyncThunk('history/change', async (_, { getState }) => {
    const s = getState();
    return s.history.present;
});
